import useFetch from '../../../../../hooks/useFetch';

const useNaboraHook = () => {
  const [fetchData] = useFetch();

  const request = (method, url, data = null) =>
    fetchData({
      method,
      url,
      ...(data && { data }),
    });

  /* ======================================================
     EXHIBITIONS
  ====================================================== */

  const getExhibitions = () =>
    request("GET", "/nabora/exhibitions");

  const getFeaturedExhibition = async () => {
    const data = await getExhibitions();

    if (!Array.isArray(data)) return null;

    return data.find((item) => item.featured) || data[0] || null;
  };

  const getExhibitionBySlug = (slug) =>
    request("GET", `/nabora/exhibitions/${slug}`);

  const createExhibition = (payload) =>
    request("POST", "/nabora/exhibitions", payload);

  const updateExhibition = (id, payload) =>
    request("PUT", `/nabora/exhibitions/${id}`, payload);

  const deleteExhibition = (id) =>
    request("DELETE", `/nabora/exhibitions/${id}`);

  /* ======================================================
     CATEGORIES
  ====================================================== */

  const getCategories = (exhibitionId) =>
    request("GET", `/nabora/categories/${exhibitionId}`);

  const createCategory = (payload) =>
    request("POST", "/nabora/categories", payload);

  const updateCategory = (id, payload) =>
    request("PUT", `/nabora/categories/${id}`, payload);

  const deleteCategory = (id) =>
    request("DELETE", `/nabora/categories/${id}`);

  /* ======================================================
     BOOTHS
  ====================================================== */

  const getBooths = (query = "") =>
    request("GET", `/nabora/booths${query}`);

  const getBooth = (id) =>
    request("GET", `/nabora/booths/${id}`);

  const createBooth = (payload) =>
    request("POST", "/nabora/booths", payload);

  const updateBooth = (id, payload) =>
    request("PUT", `/nabora/booths/${id}`, payload);

  const deleteBooth = (id) =>
    request("DELETE", `/nabora/booths/${id}`);

  /* ======================================================
     VISITORS
  ====================================================== */

  const registerVisitor = (payload) =>
    request("POST", "/nabora/visitor/register", payload);

  const addFavouriteBooth = (payload) =>
    request("POST", "/nabora/visitor/favourite", payload);

  const addRecentlyViewed = (payload) =>
    request("POST", "/nabora/visitor/recent", payload);

  const getVisitorProfile = (id) =>
    request("GET", `/nabora/visitor/${id}`);

  /* ======================================================
     ENQUIRIES
  ====================================================== */

  const createEnquiry = (payload) =>
    request("POST", "/nabora/enquiry", payload);

  const getEnquiries = () =>
    request("GET", "/nabora/enquiries");

  const updateEnquiryStatus = (id, payload) =>
    request("PUT", `/nabora/enquiries/${id}`, payload);

  const deleteEnquiry = (id) =>
    request("DELETE", `/nabora/enquiries/${id}`);

  /* ======================================================
     DASHBOARD
  ====================================================== */

  const getDashboard = () =>
    request("GET", "/nabora/dashboard");

  /* ======================================================
     ANALYTICS
  ====================================================== */

  const trackBoothView = (id) =>
    request("POST", `/nabora/analytics/view/${id}`);

  const trackWhatsAppClick = (id) =>
    request("POST", `/nabora/analytics/whatsapp/${id}`);

  const trackPhoneClick = (id) =>
    request("POST", `/nabora/analytics/phone/${id}`);

  const trackWebsiteClick = (id) =>
    request("POST", `/nabora/analytics/website/${id}`);

  return {
    getExhibitions,
    getFeaturedExhibition,
    getExhibitionBySlug,
    createExhibition,
    updateExhibition,
    deleteExhibition,

    getCategories,
    createCategory,
    updateCategory,
    deleteCategory,

    getBooths,
    getBooth,
    createBooth,
    updateBooth,
    deleteBooth,

    registerVisitor,
    addFavouriteBooth,
    addRecentlyViewed,
    getVisitorProfile,

    createEnquiry,
    getEnquiries,
    updateEnquiryStatus,
    deleteEnquiry,

    getDashboard,

    trackBoothView,
    trackWhatsAppClick,
    trackPhoneClick,
    trackWebsiteClick,
  };
};

export default useNaboraHook;